import { AppLayout } from '@/layout/appLayout'
import { ProtectedRoutes } from '@/routes/ProtectedRoutes'

export const AppWithBreadcrumbs = () => {
  return (
    <AppLayout>
      <ProtectedRoutes />
    </AppLayout>
  )
}
